import { FC, ReactNode } from "react";

import { Box } from "@mui/material";

interface FilterRowLayoutProps {
  slots: {
    type: ReactNode;
    operation: ReactNode;
    values: ReactNode;
    delete: ReactNode;
  };
}

export const FilterRowLayout: FC<FilterRowLayoutProps> = ({ slots }) => {
  return (
    <Box
      data-test="filter-row"
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "minmax(0, 1fr) auto", sm: "1fr 160px 1fr auto" },
        gridTemplateAreas: {
          xs: `"type delete" "operation operation" "values values"`,
          sm: `"type operation values delete"`,
        },
        alignItems: "center",
        gap: 1,
        width: "100%",
      }}
    >
      <Box sx={{ gridArea: "type", minWidth: 0 }}>{slots.type}</Box>
      <Box sx={{ gridArea: "operation" }}>{slots.operation}</Box>
      <Box sx={{ gridArea: "values", minWidth: 0 }}>{slots.values}</Box>
      <Box sx={{ gridArea: "delete" }}>{slots.delete}</Box>
    </Box>
  );
};
